export const seoConfig = {
  home: {
    title: "Toledo Consultora IT · SEO y Ciberseguridad en España",
    description: "Consultora IT en España: auditorías de ciberseguridad OWASP · NIS2 · GDPR, posicionamiento SEO y desarrollo web. +23 proyectos. Diagnóstico con informe desde USD 50.",
    keywords: "consultora SEO España, posicionamiento web, consultora IT, ciberseguridad OWASP, auditoría NIS2 GDPR, desarrollo web React Node.js, SEO técnico España",
    canonical: "https://toledoconsultora.com",
    ogTitle: "Toledo Consultora IT — SEO, Ciberseguridad y Desarrollo Web en España",
    ogDescription: "Auditorías OWASP · NIS2 · GDPR en 24 h. Desarrollo web React/Node.js. SEO técnico. +23 proyectos en 6 países.",
    ogImage: "https://toledoconsultora.com/img/og-image.png",
  },
  services: {
    title: "Servicios — Ciberseguridad, Desarrollo Web, SEO | Toledo Consultora IT",
    description: "Auditorías de seguridad OWASP, desarrollo web profesional con React y Node.js, SEO técnico, Google Ads y posicionamiento en IA para empresas en España y LATAM.",
    keywords: "servicios ciberseguridad, auditoría OWASP, desarrollo web React, SEO técnico, Google Ads, posicionamiento IA, consultoría digital España",
    canonical: "https://toledoconsultora.com/desarrollo-web",
  },
  seoPositioning: {
    title: "SEO Técnico y Posicionamiento Web — Toledo Consultora IT",
    description: "Posicionamiento web profesional para empresas en España y LATAM. SEO técnico, SEO local, Google Business Profile y posicionamiento en ChatGPT y Gemini.",
    keywords: "SEO técnico España, posicionamiento web, SEO local, Google Business Profile, posicionamiento IA, AIO optimization",
    canonical: "https://toledoconsultora.com/about-posicionamiento",
  },
  googleAds: {
    title: "Google Ads y Meta Ads — Toledo Consultora IT | Campañas de Alto Rendimiento",
    description: "Campañas de Google Ads y Meta Ads con seguimiento de conversiones y creativos optimizados. Máximo ROI para pymes en España y LATAM.",
    keywords: "Google Ads España, Meta Ads, campañas SEM, PPC profesional, publicidad digital pymes, remarketing",
    canonical: "https://toledoconsultora.com/about-google-ads",
  },
  googleBusiness: {
    title: "Google Business Profile — Toledo Consultora IT | Visibilidad Local",
    description: "Optimización profesional de Google Business Profile para aparecer en búsquedas locales y Google Maps. Estrategia de reseñas y SEO local.",
    keywords: "Google Business Profile, SEO local, Google Maps, reseñas Google, visibilidad local, ficha Google",
    canonical: "https://toledoconsultora.com/about-google-business",
  },
  landingPages: {
    title: "Landing Pages de Alta Conversión — Toledo Consultora IT",
    description: "Diseño y desarrollo de landing pages optimizadas para conversión. Integración con Google Ads, SEO on-page y arquitectura segura.",
    keywords: "landing page conversión, diseño landing page, landing page Google Ads, landing page SEO, desarrollo web profesional",
    canonical: "https://toledoconsultora.com/about-landing-page",
  },
  reviews: {
    title: "Gestión de Reseñas en Google — Toledo Consultora IT",
    description: "Estrategia profesional de reseñas para mejorar tu reputación online. Más estrellas, más confianza, más clientes.",
    keywords: "gestión reseñas Google, reputación online, estrategia reviews, opiniones Google, Google Business reseñas",
    canonical: "https://toledoconsultora.com/about-reseñas",
  },
  socialMedia: {
    title: "Redes Sociales para Empresas — Toledo Consultora IT",
    description: "Gestión estratégica de redes sociales para empresas. Contenido, pauta y análisis en Instagram, Facebook y LinkedIn.",
    keywords: "redes sociales empresas, community manager, Instagram marketing, Facebook Ads, LinkedIn empresas, social media strategy",
    canonical: "https://toledoconsultora.com/about-redes-sociales",
  },
  ecommerce: {
    title: "Ecommerce Seguro con React y Node.js — Toledo Consultora IT",
    description: "Desarrollo de tiendas online con arquitectura segura. Integración MercadoPago, catálogo filtrable, chatbot IA y sistema white-label.",
    keywords: "ecommerce seguro, tienda online React, integración MercadoPago, ecommerce Node.js, tienda virtual profesional, white-label",
    canonical: "https://toledoconsultora.com/desarrollo-web",
  },
  dominio: {
    title: "Registro de Dominios y Hosting — Toledo Consultora IT",
    description: "Registrá tu dominio profesional (.com, .com.ar, .es) con configuración DNS, SSL y redirecciones incluidas.",
    keywords: "registro dominio, dominio .com.ar, dominio .es, hosting profesional, configuración DNS, certificado SSL",
    canonical: "https://toledoconsultora.com/about-comprar-dominio",
  },
  about: {
    title: "Sobre Nosotros — Toledo Consultora IT | Ciberseguridad y Desarrollo Web",
    description: "Consultora IT con +5 años de experiencia. Especialistas en ciberseguridad OWASP, desarrollo web React/Node.js y SEO técnico. Proyectos en 6 países.",
    keywords: "sobre Toledo Consultora IT, consultora ciberseguridad, equipo desarrollo web, experiencia React Node.js, proyectos internacionales",
    canonical: "https://toledoconsultora.com/#about",
  },
  contact: {
    title: "Contacto — Toledo Consultora IT | Consulta Gratuita en 24 h",
    description: "Solicitá una consulta gratuita sobre ciberseguridad, desarrollo web o SEO. Respondemos en menos de 24 horas.",
    keywords: "contacto Toledo Consultora IT, consulta gratuita, presupuesto ciberseguridad, presupuesto web, asesoramiento digital",
    canonical: "https://toledoconsultora.com/#contact",
  },
  portfolio: {
    title: "Portfolio — Proyectos en 6 Países | Toledo Consultora IT",
    description: "Proyectos reales: ecommerce, SaaS, sistemas electorales, plataformas P2P y auditorías de seguridad en Argentina, Colombia, Paraguay, EEUU, Australia y España.",
    keywords: "portfolio desarrollo web, proyectos React, casos de éxito, ecommerce MercadoPago, sistemas electorales, plataformas P2P",
    canonical: "https://toledoconsultora.com/desarrollo-web",
  },
  testimonials: {
    title: "Testimonios de Clientes — Toledo Consultora IT",
    description: "Opiniones reales de clientes en España y LATAM. Proyectos entregados con auditoría de seguridad, desarrollo web y SEO técnico.",
    keywords: "testimonios clientes, opiniones Toledo Consultora, reseñas servicios, clientes satisfechos, referencias profesionales",
    canonical: "https://toledoconsultora.com/#testimonials",
  },
  team: {
    title: "Equipo — Toledo Consultora IT | Ingeniería de Software y Ciberseguridad",
    description: "Equipo especializado en ingeniería de software, ciberseguridad OWASP y SEO técnico. Formación continua en NIS2, GDPR y DevSecOps.",
    keywords: "equipo ciberseguridad, ingenieros software, especialistas OWASP, consultores NIS2 GDPR, profesionales DevSecOps",
    canonical: "https://toledoconsultora.com/#team",
  },
  blog: {
    title: "Blog — Ciberseguridad, Desarrollo Web y SEO | Toledo Consultora IT",
    description: "Artículos técnicos sobre ciberseguridad OWASP, desarrollo web React/Node.js, SEO técnico y normativa europea NIS2/GDPR.",
    keywords: "blog ciberseguridad, artículos OWASP, tutoriales React, SEO técnico, normativa NIS2, GDPR guía",
    canonical: "https://toledoconsultora.com/blog",
  },
  cotizaciones: {
    title: "Servicios Web y Ciberseguridad — Planes y Precios | Toledo Consultora IT",
    description: "Planes de desarrollo web, auditoría de seguridad y campañas SEO con precios de referencia. Generá tu presupuesto personalizado en PDF gratis.",
    keywords: "precios desarrollo web, planes ciberseguridad, precio auditoría seguridad, cotización SEO, generador de presupuesto",
    canonical: "https://toledoconsultora.com/servicios-profesionales",
  },
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "ProfessionalService"],
  "name": "Toledo Consultora IT",
  "alternateName": ["Toledo Consultora", "Toledo IT Consulting"],
  "description": "Consultora IT especializada en ciberseguridad OWASP, NIS2 y GDPR. Desarrollo web profesional con React y Node.js. SEO técnico y posicionamiento en IA para España y LATAM.",
  "image": "https://toledoconsultora.com/img/og-image.png",
  "logo": "https://toledoconsultora.com/img/logo.png",
  "url": "https://toledoconsultora.com",
  "telephone": "+54 376 422 1063",
  "email": "info@toledoconsultora.com",
  "priceRange": "$$",
  "currenciesAccepted": "EUR, ARS, USD",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "bestRating": "5",
    "worstRating": "1",
    "reviewCount": "16"
  },
  "areaServed": [
    { "@type": "Country", "name": "España" },
    { "@type": "Country", "name": "Argentina" },
    { "@type": "AdministrativeArea", "name": "América Latina" }
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "c. 52 22, C. 52 B 22",
    "addressLocality": "Posadas",
    "addressRegion": "Misiones",
    "postalCode": "N3300",
    "addressCountry": "AR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -27.3681118,
    "longitude": -55.9514501
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "07:00",
    "closes": "18:00"
  },
  "sameAs": [
    "https://www.facebook.com/people/Toledo-Consultora-It/61567966653297/",
    "https://www.instagram.com/toledoconsultora"
  ]
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Toledo Consultora IT",
  "url": "https://toledoconsultora.com",
  "logo": "https://toledoconsultora.com/img/logo.png",
  "description": "Consultora IT especializada en ciberseguridad OWASP, NIS2 y GDPR. Desarrollo web React/Node.js. SEO técnico. España y LATAM.",
  "sameAs": [
    "https://www.facebook.com/people/Toledo-Consultora-It/61567966653297/",
    "https://www.instagram.com/toledoconsultora"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "telephone": "+54 376 422 1063",
    "email": "info@toledoconsultora.com",
    "availableLanguage": ["Spanish", "English"]
  }
};

export const serviceSchema = (serviceType) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceType,
  "description": `Servicio profesional de ${serviceType} para empresas en España y América Latina`,
  "provider": {
    "@type": "ProfessionalService",
    "name": "Toledo Consultora IT",
    "url": "https://toledoconsultora.com"
  },
  "areaServed": [
    { "@type": "Country", "name": "España" },
    { "@type": "Country", "name": "Argentina" },
    { "@type": "AdministrativeArea", "name": "América Latina" }
  ]
});
